import React from 'react';

import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import env from 'env/env';

const { reCaptchaPublicKey } = env;

const ReCaptchaHOC =
  Component =>
  ({ ...props }) => (
    <GoogleReCaptchaProvider reCaptchaKey={reCaptchaPublicKey}>
      <Component {...props} useGoogleReCaptcha={useGoogleReCaptcha} />
    </GoogleReCaptchaProvider>
  );

export default ReCaptchaHOC;
